// Unauthorized.js
import React from 'react';
import { Icon } from '@iconify/react';

export default function Unauthorized() {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-64px)] bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-lg p-10 max-w-md w-full text-center
                      animate-fadeIn animate-slideUp">
        {/* Icono con pulso sutil */}
        <div className="flex justify-center mb-6">
          <Icon 
            icon="mdi:alert-circle-outline" 
            className="w-16 h-16 text-red-600 animate-pulse" 
          />
        </div>

        {/* Mensaje */}
        <h1 className="text-2xl font-bold mb-2 text-gray-800">
          No autorizado
        </h1>
        <p className="text-gray-600">
          No tienes permisos para acceder a esta sección.
        </p>
      </div>
    </div>
  );
}
